import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
// import {SAVE_RESUME} from '../constants/constants'
import EditorSkills from './EditorSkills';
import EditorEducationHistory from './EditorEducationHistory';
import EditorWorkHistory from './EditorWorkHistory';
import BreadcrumComponent from './BreadcrumbComponent';
import Layout from './common/Layout';
import RightSection from './editor/RightSection';
import EditorHeading from './EditorHeading';
import AdditionalSections from './AdditionalSections';
import '../assets/scss/app/blocks/allinone-editor.scss';
import { useResume } from '../context/ResumeContext';
import { scroll2Id } from '../helper';
//import RearrangeSectionsPopup from './popup/RearrangeSectionsPopup';
import RearrangeSectionsComponent from './QuickEditor/RearrangeSectionsComponent';
import { BREADCRUMB_LINKS, FINAL_RESUME, PAID_SERVICES, POPUP_TYPES, MEMBERSHIP, ADDITIONAL_SECTIONS_LINK, SUMMARY_LINK, HEADING_LINK, COVERLETTER_EXPERIENCE, APP_DOMAIN } from '../constants/constants';
import { Redirect, useHistory } from "react-router-dom";
import WpAPI from '../WpApi';
import downloadResume from '../downloadResume';
import { 
  userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction, 
  setResumeFormat 
} from '../services/actions/actions';
import { usePopup } from '../context/PopupContext';
import { removeBodyScroll } from '../helper';
import EditorSummary from './EditorSummary';
import { useUser } from '../context/UserContext';

const EditorAccordianAllSections = (props) => {
  const history = useHistory()
  const dispatch = useDispatch();
  const popupbox = usePopup();
  const [spinner, setSpinner] = useState(false);
  const [showRearrange, setShowRearrange] = useState(false);
  const [loader, setLoader] = useState({download: false, save: false, share: false, print: false});
  const {
    resume,
    scroll2_active_section,
    handlers: {
      updateResumePreview,
      onsaveResume,
      nuteralizeNextClick
    },
    currentResume
  } = useResume();
  const {
    checkMembership,
    plan,
    user
  } = useUser();
  const [openTabs, setopenTabs] = useState({
      heading:false,
      education:false,
      work_history:false,
      skills:false,
      summary: false,
      additional_sections: false
  });

  const mounted = useRef(false);

  useEffect(() => {
      mounted.current = true;
      return () => {
          mounted.current = false;
      };
  }, []);

  const tabStatus = (t) => {
    if (openTabs[t]) return 'opened'
    else return 'open'
  }
  const tabClicked = (t, editName) => {
      //Only enabled tabs
      setopenTabs({ ...openTabs, [t]: editName ? true : !openTabs[t]});
      openTabs[t] || updateResumePreview({ current_tab: t });
      //temporary
      onsaveResume();
  }
  const initAccordianState = () => {
    const active = {}
    Object.keys(openTabs).forEach(v => active[v] = v==resume.current_tab ? true : false)
    setopenTabs({ ...active } )
    // window.scrollTo()
    if(resume.current_tab && scroll2_active_section){
      nuteralizeNextClick({scroll2_active_section:false})
      scroll2Id(`${resume.current_tab}_tab`, 0)
    }
  }

  useEffect(() => {
    popupbox.configurePopup(POPUP_TYPES);
  }, []);

  useEffect(() => {
    initAccordianState();
  }, []);
  
  // useEffect(() => {
  //   //this variable will after the features available in quick editor page only
  //   WpAPI.isLoggedIn() && plan == 'pro' && resume?.prime_features && updateResumePreview({ prime_features: null });
  // }, [resume?.prime_features, plan]);

  useEffect(() => {
    if (plan != null){
      //This is coming from Quick Editor Traditional page. When user clicks the download button.
      const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
      const clickAction = (localStorage.getItem('clickAction') ?? false);
      const referrer = (localStorage.getItem('referrer') ?? false);
      let isReferrerIsTraditionaEditor = false;
      if(referrer){
        isReferrerIsTraditionaEditor = (referrer == ADDITIONAL_SECTIONS_LINK || referrer == SUMMARY_LINK || referrer == FINAL_RESUME)
      }
      if(downloadOnAllinonePageLoad && clickAction == 'download' && isReferrerIsTraditionaEditor){
        removeBodyScroll(true);
        // const downloadFormat = (localStorage.getItem('downloadFormat') ?? false);
        // if(downloadFormat){
        //   dispatch(setResumeFormat(downloadFormat));
        //   localStorage.removeItem('downloadFormat');
        // }
        checkMembershipAction(download);
        localStorage.getItem('downloadOnAllinonePageLoad') && localStorage.removeItem('downloadOnAllinonePageLoad');
        localStorage.removeItem('clickAction');
      }else{
        localStorage.getItem('downloadOnAllinonePageLoad') && localStorage.removeItem('downloadOnAllinonePageLoad');
        localStorage.removeItem('clickAction');
      }
      // else{
      //   checkMembershipAction();
      // }
    }
  }, [plan]);

  const downloadHandler = (downloadFormat) => {
    downloadResume(
      {resume, currentResume, user}, 
      user, 
      () => { 
        popupbox.close('download');
        popupbox.show('askfor_trustpilot_review', null, () => {
          window.open( `https://www.trustpilot.com/review/resumetemplates.com`, '_blank');
        });
      }, 
      downloadFormat, 
      {type: 'resume', name: 'Resume' });
    // gaTrack('RT App', `Quick Editor`, 'Header Download');
    // ga4Track('app_header_download', 'RT App', 'Header Download');
    ga4Track('app_bottom_nav_download', 'RT App', 'Bottom Nav: Download');
  }

  const download = () => {
    if(WpAPI.isLoggedIn()){
        if(PAID_SERVICES){
            if(plan == 'pro'){
              popupbox.show('download', null, (params) => downloadHandler(params.downloadFormat), {plan: plan, entity: {type: 'resume', name: 'Resume' }})
            }else history.push(MEMBERSHIP);
        }else{
          popupbox.show('download', null, () => downloadHandler(), {plan: plan, entity: {type: 'resume', name: 'Resume' }})
        }
        userCompletesSectionsDownloadsPrintsOrShares();
    }
    ga4Track('app_allinone_download', 'RT App', 'Download');
  }

  const userCompletesSectionsDownloadsPrintsOrShares = () => {
      dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...resume}, 'currentResume')).then(res => {
          if(res.completed){
              const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
              const el = (
                  PAID_SERVICES && plan == 'pro' 
                  ? 'User completes sections: Downloads, Prints or Shares' 
                  : 'Free user completes sections: tries to download, print, share'
              );
              ga4Track(ec, 'RT App', el)
          }
      })
  }

  const checkMembershipAction = (callback = false, params = false) => {
    if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
    checkMembership(() => {
      if(typeof callback == 'function'){
        callback(params);
        if(mounted.current) setLoader({...loader, [callback.name]: false});
      }
    });
  }

  const redirectTo = () => {
    const ct = resume.current_tab;
    return (BREADCRUMB_LINKS.hasOwnProperty(ct)) ?
      BREADCRUMB_LINKS[ct].link :
      BREADCRUMB_LINKS['heading'].link;
  }
  //Other then intial state load use case, it will redirect in case url hit and its not completed
  if( !resume.heading.email.length && resume.enabled_tabs.length == 1) return <Redirect to={HEADING_LINK} />

  //Dont allow free and uncompleted first section to this page
  if ((!WpAPI.isLoggedIn() || (WpAPI.isLoggedIn() && plan == 'basic')) && (resume.heading.email.length || resume.heading.created_date?.length) && resume.enabled_tabs.length > 1) return <Redirect to={FINAL_RESUME} />


  return (
    <Layout
      editorType="allinone"
      left={!showRearrange 
        ? <>
          <div className={`allinone-personal`} id="heading_tab">
            <EditorHeading tabClicked = {(t, editName) => tabClicked('heading', editName)} tabOpened = {openTabs['heading']} />
          </div>
          <div className={`allinone-workhistory`} id="work_history_tab">
            <EditorWorkHistory  tabClicked = {(t, editName) => tabClicked('work_history', editName)} tabOpened = {openTabs['work_history']} />
          </div>
          <div className={`allinone-education`} id="education_tab">
            <EditorEducationHistory tabClicked = {(t, editName) => tabClicked('education', editName)} tabOpened = {openTabs['education']} />
          </div>
          <div className={`allinone-skills`} id="skills_tab">
           <EditorSkills  tabClicked = {(t, editName) => tabClicked('skills', editName)} tabOpened = {openTabs['skills']} />
          </div>
          <div className={`allinone-additionals`} id="additional_sections_tab">
            <AdditionalSections tabClicked = {() => tabClicked('additional_sections')} tabOpened = {openTabs['additional_sections']} />
          </div>
          <div className={`allinone-summary`} id="summary_tab">
            <EditorSummary tabClicked = {(t, editName) => tabClicked('summary', editName)} tabOpened = {openTabs['summary']} />
          </div>
          {/* <RearrangeSectionsPopup /> */}
        </> 
        : <RearrangeSectionsComponent 
            showRearrange={showRearrange}
            setShowRearrange={(s) => setShowRearrange(s)}
          />
      }

      right={<RightSection current_tab={resume.current_tab} resume={resume} />}
      breadcrumb={!resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={resume.enabled_tabs} /> : false}
      leftPanel={props.leftPanel}
      showRearrange={showRearrange}
      setShowRearrange={(s) => setShowRearrange(s)}
    />
  );
}

export default EditorAccordianAllSections;